function HealthPage() {
	return <div>Health Check: OK</div>;
}

export default HealthPage;
